"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _themeDefinition = _interopRequireDefault(require("./themeDefinition"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GSCTheme = (0, _styles.responsiveFontSizes)((0, _styles.createMuiTheme)(_themeDefinition.default));

var GSCMaterial = function GSCMaterial(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_styles.MuiThemeProvider, {
    theme: GSCTheme
  }, _react.default.createElement(_core.CssBaseline, null), children);
};

var _default = GSCMaterial;
exports.default = _default;